export const isValidEmail = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const email = value.trim();
  if (!email || email.includes(' ')) {
    return false;
  }

  const atIndex = email.indexOf('@');
  if (atIndex <= 0 || atIndex !== email.lastIndexOf('@') || atIndex === email.length - 1) {
    return false;
  }

  const localPart = email.slice(0, atIndex);
  const domainPart = email.slice(atIndex + 1);

  if (!localPart || !domainPart || domainPart.startsWith('.') || domainPart.endsWith('.')) {
    return false;
  }

  const domainSegments = domainPart.split('.');
  return domainSegments.length >= 2 && !domainSegments.some((segment) => !segment);
};

export const normalizePostalCodeValue = (value = '') => (
  String(value)
    .replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xFEE0))
    .replace(/－/g, '-')
    .trim()
);

export const filterAllowedCharacters = (value, allowedCharactersRegex) => {
  if (!allowedCharactersRegex) {
    return value;
  }

  const source = allowedCharactersRegex.source;
  const match = source.match(/^\^\[(.+)\][+*]\$$/);
  if (!match) {
    return value;
  }

  const disallowed = new RegExp(`[^${match[1]}]`, 'g');
  return String(value).replace(disallowed, '');
};

export const normalizeAddressFieldValue = (field, value) => (
  field === 'postalCode' ? normalizePostalCodeValue(value) : value
);
